import { f as u } from "./index743.mjs";
import { f } from "./index758.mjs";
import { i as l } from "./index761.mjs";
import { c as v } from "./index766.mjs";
import { g as p } from "./index793.mjs";
import { i as m } from "./index831.mjs";
var C = u, y = f, s = l, h = v, R = p, T = m, n = function() {
}, a = R("Reflect", "construct"), o = /^\s*(?:class|function)\b/, $ = C(o.exec), b = !o.test(n), t = function(r) {
  if (!s(r))
    return !1;
  try {
    return a(n, [], r), !0;
  } catch {
    return !1;
  }
}, e = function(r) {
  if (!s(r))
    return !1;
  switch (h(r)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  try {
    return b || !!$(o, T(r));
  } catch {
    return !0;
  }
};
e.sham = !0;
var d = !a || y(function() {
  var c;
  return t(t.call) || !t(Object) || !t(function() {
    c = !0;
  }) || c;
}) ? e : t;
export {
  d as i
};
